import React from 'react';
import { Accordion, FilterAccordionHeader } from '@folio/stripes/components';
import { MultiSelectionFilter } from '@folio/stripes/smart-components';
import { RECORD_TYPES_FILTER_KEY } from '../constants';
import { filterEntityTypes } from './helpers';
export var RecordTypesFilter = function (_a) {
    var selectedRecordTypes = _a.selectedRecordTypes, recordTypeConfig = _a.recordTypeConfig, onChange = _a.onChange, onClear = _a.onClear;
    return (React.createElement(Accordion, { label: recordTypeConfig.label, separator: false, 
        // @ts-ignore
        header: FilterAccordionHeader, displayClearButton: selectedRecordTypes.length > 0, onClearFilter: function () { return onClear(RECORD_TYPES_FILTER_KEY); } },
        React.createElement(MultiSelectionFilter
        // @ts-ignore
        , { 
            // @ts-ignore
            filter: filterEntityTypes, name: RECORD_TYPES_FILTER_KEY, dataOptions: recordTypeConfig.values, onChange: function (_a) {
                var values = _a.values;
                onChange(values);
            }, selectedValues: selectedRecordTypes })));
};
